import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ChevronLeft = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 16 16"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        d="M10.764 12.921a.5.5 0 0 1-.685.176l.255-.43-.255.43-.004-.003-.011-.006-.041-.025-.153-.094a23.23 23.23 0 0 1-2.18-1.53c-.596-.475-1.21-1.023-1.678-1.587C5.559 9.307 5.167 8.66 5.167 8s.392-1.306.845-1.852c.469-.564 1.082-1.112 1.677-1.586a23 23 0 0 1 2.333-1.625l.042-.025.01-.006.005-.003.255.43-.255-.43a.5.5 0 0 1 .51.86m0 0-.003.002-.009.005-.037.023a18 18 0 0 0-.66.42c-.43.283-1 .679-1.568 1.131-.571.455-1.125.954-1.531 1.443-.422.509-.614.921-.614 1.213s.192.705.614 1.213c.406.49.96.989 1.531 1.443a22 22 0 0 0 2.229 1.551l.036.023.01.005.001.001a.5.5 0 0 1 .176.685"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default ChevronLeft;
